import { render, staticRenderFns } from "./cardTableProducts.vue?vue&type=template&id=1bb3ebf5&"
import script from "./cardTableProducts.vue?vue&type=script&lang=js&"
export * from "./cardTableProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports